const SET_COMPONENT_ANSWER = 'SET_COMPONENT_ANSWER';
const INIT_COMPONENT_RATINGS = 'INIT_COMPONENT_RATINGS';

/**
 * When a component card is dragged into a column
 */
export const setComponentAnswer = (data) => {
    return {
        type: SET_COMPONENT_ANSWER,
        data
    };
};

/**
 * Called when the page is rendered. Sets the components default rating.
 */
export const initComponentRatings = () => {
    return {
        type: INIT_COMPONENT_RATINGS
    };
};



// WEBPACK FOOTER //
// ./application/containers/Components/actions.js